"use client"

import * as React from "react"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { SectionContainer } from "@shared/ui/landing/section-container"
import { StatCounter } from "@shared/ui/landing/stat-counter"
import { LiveBadge } from "@shared/ui/landing/status-tag"

import { networkStats, pulsePoints } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

const WorldPulseMap = React.lazy(() =>
  import("@shared/ui/landing/world-pulse-map").then((mod) => ({
    default: mod.WorldPulseMap,
  })),
)

export function WorldPulseSection() {
  const t = useTranslations("worldPulse")

  return (
    <SectionContainer id="network" className="py-12 md:py-20">
      <div className="mb-8 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center md:mb-10">
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <h2 className="text-2xl font-bold tracking-tight md:text-3xl">
              {t("title")}
            </h2>
            <LiveBadge label={t("live")} />
          </div>
          <p className="max-w-xl text-muted-foreground">{t("subtitle")}</p>
        </div>
      </div>

      <GlassCard className="cyber-border overflow-hidden p-2 md:p-4">
        <React.Suspense
          fallback={<div className="aspect-[2/1] animate-pulse rounded-2xl bg-white/5" />}
        >
          <WorldPulseMap points={pulsePoints} className="text-sky-400/30" />
        </React.Suspense>
      </GlassCard>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        {networkStats.map((stat) => (
          <GlassCard key={stat.id} className="cyber-border text-center">
            <StatCounter
              value={stat.value}
              suffix={stat.suffix}
              className="text-2xl font-bold text-sky-400 md:text-3xl"
            />
            <p className="mt-1 text-sm text-muted-foreground">{t(stat.labelKey)}</p>
          </GlassCard>
        ))}
      </div>
    </SectionContainer>
  )
}
